import { useEffect, useState } from 'react';
import { apiFetch } from '../apiFetch';

export const CADASTRAL_PILOT = '3ece9bc70890c09e304cb11510ef8586';
export default function usePlantClarificationIndex({ tenantId, revision, ready, refreshToken }) {
  const [snapshot, setSnapshot] = useState(null);
  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    setSnapshot(null);
    if (tenantId !== CADASTRAL_PILOT || !ready || !revision) return () => controller.abort();
    const timer = setTimeout(() => controller.abort(), 15000);
    const base = `/api/cadastral-clarifications/${encodeURIComponent(tenantId)}`;
    async function get(path) {
      const response = await apiFetch(base + path, { signal: controller.signal });
      if (!response.ok) throw new Error('Leitura indisponível');
      return response.json();
    }
    (async () => {
      try {
        const capabilities = await get('/capabilities');
        if (capabilities.enabled === false) return;
        if (capabilities.enabled !== true) throw new Error('Disponibilidade inválida');
        const pending = new Set(), cursors = new Set();
        let after = null;
        do {
          const query = new URLSearchParams({ sourceKind: 'LEGACY_PLANT_SERVICE', limit: '50' });
          if (after) query.set('after', after);
          const page = await get(`?${query}`);
          if (!Array.isArray(page.records) || page.sourceRevision !== revision
            || !(page.nextCursor === null || typeof page.nextCursor === 'string' && page.nextCursor.length > 0)) throw new Error('Revisão divergente');
          for (const record of page.records) {
            const source = record.question?.source;
            if (source?.tenantId !== tenantId || source.sourceKind !== 'LEGACY_PLANT_SERVICE'
              || typeof source.sourceId !== 'string' || !source.sourceId
              || !['PENDING', 'ANSWERED', 'OBSOLETE'].includes(record.state)
              || record.qualification !== 'NOT_PERFORMED' || record.runtimeConsumable !== false) throw new Error('Fonte inválida');
            if (record.state === 'PENDING') {
              if (source.sourceRevision !== revision) throw new Error('Pergunta obsoleta');
              pending.add(source.sourceId);
            }
          }
          after = page.nextCursor;
          if (after && cursors.has(after)) throw new Error('Paginação inconsistente');
          if (after) cursors.add(after);
        } while (after);
        if (active && !controller.signal.aborted) setSnapshot({ tenantId, revision, refreshToken, pending, error: '' });
      } catch {
        if (active) setSnapshot({ tenantId, revision, refreshToken, pending: new Set(), error: 'Não foi possível verificar os indicadores de esclarecimento. Recarregue as dúvidas no elemento.' });
      } finally { clearTimeout(timer); }
    })();
    return () => { active = false; controller.abort(); clearTimeout(timer); };
  }, [tenantId, revision, ready, refreshToken]);
  return ready && snapshot?.tenantId === tenantId && snapshot.revision === revision && snapshot.refreshToken === refreshToken
    ? snapshot : { pending: new Set(), error: '' };
}
